import { createContext, useContext, useEffect, useState } from 'react';
import { translations } from '../i18n/translations';

const LanguageContext = createContext(null);

function detectDefaultLanguage() {
  const stored = localStorage.getItem('app_lang');
  if (stored === 'zh' || stored === 'en') return stored;
  const browserLang = (navigator.language || '').toLowerCase();
  return browserLang.startsWith('en') ? 'en' : 'zh';
}

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(detectDefaultLanguage);

  useEffect(() => {
    localStorage.setItem('app_lang', lang);
  }, [lang]);

  const toggleLang = () => setLang((prev) => (prev === 'zh' ? 'en' : 'zh'));

  const t = (key, arg) => {
    const node = key.split('.').reduce((acc, part) => acc?.[part], translations[lang]);
    return typeof node === 'function' ? node(arg) : node ?? key;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
